import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuHorizonIcon extends BaseIcon {
  getChildren = () => [
    <g transform="translate(0 8.08)">
      <path fill="#e35785" d="M29.97 6.5c12.712 0 23.024 9.757 23.095 21.817H60C59.893 12.659 46.5 0 30 0S.107 12.659 0 28.314h6.875C6.946 16.253 17.258 6.5 29.97 6.5"/>
      <path fill="#cb1f47" d="M29.968 6.497c-12.712 0-23.024 9.757-23.095 21.817h4.321c.081-9.786 8.454-17.7 18.774-17.7s18.7 7.914 18.776 17.7h4.324c-.074-12.06-10.386-21.817-23.1-21.817"/>
      <path fill="#a51339" d="M29.97 13.13c-8.815 0-15.969 6.751-16.049 15.108h32.1c-.08-8.357-7.234-15.108-16.049-15.108"/>
      <path fill="#099696" d="M18.746 39.551h22.449a15.754 15.754 0 0 0 1.867-2.027H16.879a15.754 15.754 0 0 0 1.867 2.027"/>
      <path fill="#099696" d="M45.993 30.789H13.948a14.725 14.725 0 0 0 1.336 4.174h29.372a14.706 14.706 0 0 0 1.337-4.174"/>
      <path fill="#099696" d="M29.97 43.84a16.828 16.828 0 0 0 7.492-1.742H22.478a16.828 16.828 0 0 0 7.492 1.741"/>
    </g>
  ]
  getViewBox = () => '0 0 60 60'
}
